import { useTenant } from "@/providers/session";
import { useFeatureFlagEnabled, useFeatureFlagPayload } from "posthog-js/react";

export default function useLedgerFeatureFlag() {
  const { tenantId } = useTenant();
  const isEnabled = useFeatureFlagEnabled("is-bank-enabled");
  const payload = useFeatureFlagPayload("is-bank-enabled");

  if (!isEnabled) {
    return {
      isLedgerEnabled: false,
    };
  }

  if (typeof payload !== "string") {
    return {
      isLedgerEnabled: false,
    };
  }

  return {
    isLedgerEnabled: payload.split(",").includes(tenantId),
  };
}
